import { NgModule } from '@angular/core';
import { PlaceHolderLibraryModule } from 'place-holder-library';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { LcaContainerComponent } from './lca-container.component';
import { SelectingLcaSocLibraryModule } from 'selecting-lca-soc-library';
import { LcaSocCodeLibraryModule } from 'lca-soc-code-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import { HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { CustomQuestionnaireModule } from 'custom-questionnaire';

@NgModule({
  declarations: [LcaContainerComponent],
  imports: [
    PrimengLibraryModule,
    StepStatusUpdateComponentLibraryModule,
    PlaceHolderLibraryModule,
    SelectingLcaSocLibraryModule,
    LcaSocCodeLibraryModule,
    LastUpdateLibraryModule,
    HelpVideoOverlayLibraryModule,
    AssigningTaskLibraryModule,
    MaximizeDialogLibraryModule,
    CustomQuestionnaireModule,
  ],
  exports: [LcaContainerComponent]
})
export class LcaContainerModule { }
